import { darkDimmedTheme } from './darkDimmedTheme';
import { darkHighContrastTheme } from './darkHighContrastTheme';
import { darkProtanopiaAndDeuteranopiaTheme } from './darkProtAndDeuterTheme';
import { darkTritanopiaTheme } from './darkTritanopiaTheme';
import { lightHighContrastTheme } from './lightHighContrastTheme';
import { lightProtAndDeuterTheme } from './lightProtAndDeuterTheme';
import { lightTheme } from './lightTheme';
import { lightTritanopiaTheme } from './lightTritanopiaTheme';
import { realDarkTheme } from './realDarkTheme';
import { ThemeConfigType, ThemeTypes } from './typing';

export class Themes {
  static Light: ThemeConfigType = lightTheme;
  static LightHighContrast: ThemeConfigType = lightHighContrastTheme;
  static LightProtanopiaAndDeuteranopia: ThemeConfigType = lightProtAndDeuterTheme;
  static LightTritanopia: ThemeConfigType = lightTritanopiaTheme;
  static Dark: ThemeConfigType = realDarkTheme;
  static DarkHighContrast: ThemeConfigType = darkHighContrastTheme;
  static DarkProtanopiaAndDeuteranopia: ThemeConfigType = darkProtanopiaAndDeuteranopiaTheme;
  static DarkTritanopia: ThemeConfigType = darkTritanopiaTheme;
  static DarkDimmed: ThemeConfigType = darkDimmedTheme;

  private static themeMap: { [key in ThemeTypes]?: ThemeConfigType } = {
    'light-default': Themes.Light,
    'light-high-contrast': Themes.LightHighContrast,
    'light-protanopia-and-deuteranopia': Themes.LightProtanopiaAndDeuteranopia,
    'light-tritanopia': Themes.LightTritanopia,
    'dark-default': Themes.Dark,
    'dark-high-contrast': Themes.DarkHighContrast,
    'dark-protanopia-and-deuteranopia': Themes.DarkProtanopiaAndDeuteranopia,
    'dark-tritanopia': Themes.DarkTritanopia,
    'dark-dimmed': Themes.DarkDimmed,
  };

  static getTheme = (themeType: ThemeTypes): ThemeConfigType | undefined => {
    return Themes.themeMap[themeType] || Themes.Light;
  };

  static getAllThemes() {
    return [
      Themes.Light,
      Themes.LightHighContrast,
      Themes.LightProtanopiaAndDeuteranopia,
      Themes.LightTritanopia,
      Themes.Dark,
      Themes.DarkHighContrast,
      Themes.DarkProtanopiaAndDeuteranopia,
      Themes.DarkTritanopia,
      Themes.DarkDimmed,
    ];
  }
}
